import { Checkbox, getLoggedIn, Translation as T, useTranslation } from "@awe-web/shared/lib";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { Button, ScrollToError } from "../../components/form.js";
import { FormikMultiChoiceOptions, FormikSingleChoiceOptions } from "../../components/option.js";
import { ScreenHeading, ScreenSection } from "../../components/screen.js";
import {
  getStrEquipmentOptions,
  getStrMileageOptions,
  newGetStrSelectExtrasFormValuesToTotalPrice
} from "../store.js";
import { StrBasePrice, StrTotalPrice } from "./price";

import "./str_select_extras_form.scss";

const SELECT_EXTRAS = "FSD0000125";
const SELECT_MILEAGE_B2C = "FSD0000248";
const SELECT_MILEAGE_B2B = "ALG0000251";
const SELECT_DEDUCTIBLE = "FSD0000249";
const SELECT_EQUIPMENT = "FSD0000252";
const CONTINUE = "FSD0000135";
const MORE_INFOS_MILEAGE_HEADING_B2C = "ALG0000237";
const MORE_INFOS_MILEAGE_CONTENT_B2C = "ALG0000238";
const MORE_INFOS_MILEAGE_HEADING_B2B = "ALG0000252";
const MORE_INFOS_MILEAGE_CONTENT_B2B = "ALG0000253";
const MORE_INFOS_DEDUCTIBLE_HEADING = "ALG0000239";
const MORE_INFOS_DEDUCTIBLE_CONTENT = "ALG0000240";

export default function STR_SelectExtrasForm({
  values,
  handleSubmit,
  reservationPath,
  basePriceHintCode,
  deductibleOptions,
  mileageOptionsChangedMessage,
  equipmentOptionsChangedMessage,
  onGuestCheck
}) {

  const { translate } = useTranslation();

  const mileageOptions = useSelector((state) => getStrMileageOptions(state));
  const equipmentOptions = useSelector((state) => getStrEquipmentOptions(state));
  const formValuesToTotalPrice = useSelector((state) => newGetStrSelectExtrasFormValuesToTotalPrice(state));

  const totalPrice = formValuesToTotalPrice(values);

  const selectMileageTitle = reservationPath === "B2B" ? SELECT_MILEAGE_B2B : SELECT_MILEAGE_B2C;
  const moreInfosMileageHeading = reservationPath === "B2B" ? MORE_INFOS_MILEAGE_HEADING_B2B : MORE_INFOS_MILEAGE_HEADING_B2C;
  const moreInfosMileageContent = reservationPath === "B2B" ? MORE_INFOS_MILEAGE_CONTENT_B2B : MORE_INFOS_MILEAGE_CONTENT_B2C;
  const isLoggedIn = useSelector((state) => getLoggedIn(state));

  return (
    <form className="str-select-extras-form__grid-wrapper" onSubmit={handleSubmit}>
      <ScrollToError />
      <div className="str-select-extras-form__grid">
        <ScreenSection className="str-select-extras-form__title" dark>
          <div className="str-select-extras-form__type-area">
            <ScreenHeading className="str-select-extras-form__screen-heading">
              <T code={SELECT_EXTRAS} />
            </ScreenHeading>
          </div>
        </ScreenSection>

        <StrBasePrice className="str-select-extras-form__base-price-details" />

        <ScreenSection className="str-select-extras-form__extras" light>
          <div className="str-select-extras-form__type-area str-select-extras-form__type-area--extras">
            <FormikMultiChoiceOptions
              name="mileage"
              showPrices
              className="str-select-extras-form__mileage-options"
              title={translate(selectMileageTitle)}
              notice={mileageOptionsChangedMessage}
              moreInfos={{
                heading: translate(moreInfosMileageHeading),
                content: translate(moreInfosMileageContent)
              }}
              options={mileageOptions.toJS()}
            />
            <FormikSingleChoiceOptions
              name="deductible"
              showPrices
              className="str-select-extras-form__deductible-options"
              title={translate(SELECT_DEDUCTIBLE)}
              moreInfos={{
                heading: translate(MORE_INFOS_DEDUCTIBLE_HEADING),
                content: translate(MORE_INFOS_DEDUCTIBLE_CONTENT)
              }}
              options={deductibleOptions}
            />
            <FormikMultiChoiceOptions
              name="equipment"
              showPrices
              className="str-select-extras-form__equipment-options"
              title={translate(SELECT_EQUIPMENT)}
              notice={equipmentOptionsChangedMessage}
              options={equipmentOptions.toJS()}
            />
          </div>
        </ScreenSection>

        <StrTotalPrice
          reservationPath={reservationPath}
          className="str-select-extras-form__total-price"
          descriptionHint={translate(basePriceHintCode)}
          formattedPrice={totalPrice}
        />

        <ScreenSection className="str-select-extras-form__actions" dark>
          <Button primary continue submit><T code={CONTINUE} /></Button>
          {!isLoggedIn && onGuestCheck !== undefined && <label className="labeled-checkbox str-select-extras-form__as_guest">
            <Checkbox
              onChange={onGuestCheck}
              className="option-with-text-input__checkbox labeled-checkbox__input "
            />
            <T code={"FSD0000454"} />
          </label>
          }
        </ScreenSection>
      </div>
    </form>
  );
}

STR_SelectExtrasForm.propTypes = {
  reservationPath: PropTypes.oneOf(["B2C", "B2B"]),
  basePriceHintCode: PropTypes.string,
  mileageOptionsChangedMessage: FormikMultiChoiceOptions.propTypes.notice,
  deductibleOptions: FormikSingleChoiceOptions.propTypes.options,
  equipmentOptionsChangedMessage: FormikMultiChoiceOptions.propTypes.notice,
  values: PropTypes.shape({
    mileage: PropTypes.objectOf(PropTypes.bool),
    deductible: PropTypes.number,
    equipment: PropTypes.objectOf(PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.string
    ]))
  }),
  handleSubmit: PropTypes.func.isRequired
};